export default "__VITE_ASSET__DND1ZhPc__"